import React from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://datacake.co/" target="_blank" rel="noreferrer"><img src={mock01} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://datacake.co/" target="_blank" rel="noreferrer"><h2>Datacake</h2></a>
                <p>Frontend development for Datacake to develop a no-code dashboard builder for IoT applications using React, GraphQL and Tailwind.</p>
            </div>
            <div className="project">
                <a href="https://jiga.io/" target="_blank" rel="noreferrer"><img src={mock02} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://jiga.io/" target="_blank" rel="noreferrer"><h2>Jiga</h2></a>
                <p>Full-stack development for Jiga, which provides cost-effective custom parts production services directly from suppliers.</p>
            </div>
            <div className="project">
                <a href="https://sideshift.ai/" target="_blank" rel="noreferrer"><img src={mock03} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://sideshift.ai/" target="_blank" rel="noreferrer"><h2>Sideshift.ai</h2></a>
                <p>Backend development for Sideshift.ai using Typescript, Node.js and relational databases.</p>
            </div>
            <div className="project">
                <a href="https://www.agentur-brandmarker.de/" target="_blank" rel="noreferrer"><img src={mock04} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.agentur-brandmarker.de/" target="_blank" rel="noreferrer"><h2>Brandmarker</h2></a>
                <p>Full-stack development for Brandmarker to build SEO-driven websites and content mangagement systems for businesses.</p>
            </div>

        </div>
    </div>
    );
}

export default Project;
